import React from 'react';
import { Helmet } from 'react-helmet';
import banner from '../assets/Channel-Partner-Banner.png';
import PartnerIntro from '../components/PartnerIntro';
import WhyChooseDriveIn from '../components/WhyChooseDriveIn';
import StartupRequirements from '../components/StartupRequirements';
// import JoinUsSection from '../components/JoinUsSection';
import ChannelPartnerApplySection from '../components/ChannelPartnerApplySection';
import ConsultationNote from '../components/ConsultationNote';
import Hero from '../components/Hero';
import FaqSection from './../components/FaqSection';
import { Link, useNavigate } from 'react-router-dom';

// Define FAQ content here
const channelPartnerFaq = [
  {
    question: 'Do I need to have experience in car care or detailing?',
    answer: 'No prior experience is required. If you’ve been researching how to start a car wash franchise, you’ll find our onboarding process covers operations, customer handling, and service flow. We’ll also help identify the right machinery based on your budget and area.'
  },
  {
    question: 'What kind of support do I get after setup?',
    answer: 'Our franchise team will remain in touch post-launch for periodic check-ins. We help you with digital marketing templates, branding materials, SOP refreshers, and promotional ideas—so your store gets visibility and traction locally.'
  },
  {
    question: 'What is the minimum space requirement?',
    answer: 'Preferably, look at a unit of approximately 800-1000 square feet with a water hookup and convenient access to your car-or whatever you drive. We have had to fumble along with smaller dots and leaner equipment and a service-first attitude. In case you are serious about a franchise, we would assist you in determining the viability of the site.'
  },
  {
    question: 'Can I convert my existing wash bay or car garage into a Drive-In Car Spa?',
    answer: 'Yes, we offer rebranding and model-upgrade options. This lets you keep your infrastructure but benefit from the brand, service protocols, and marketing support. It’s a great option for those exploring franchise opportunities near me without starting from scratch.'
  },
  {
    question: 'How do I begin the application process?',
    answer: 'Fill out our partner interest form or contact us via phone. We’ll conduct a discovery call to understand your goals, review your location (if any), and share the onboarding flow. We prefer working with hands-on partners who can run day-to-day operations efficiently.'
  }
];

const AboutUs = () => {
  const navigate = useNavigate();
  const handleServicesClick = () => {
    navigate('/contact');
  };
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://driveincarspa.com/channelPartner" />
        <title>Best Automotive Channel Partner in Bangalore | Start Your Business
 | Drive-in Car Spa</title>
        <meta name="description" content="Looking for an automotive service channel partner in Bangalore? Partner with us for profitable business opportunities, training, and complete support." />
        <meta name="keywords" content="Car detailing dealership in Bangalore, car wash partnership near me, best Car spa business partnership, Automotive service channel partner in Bangalore " />
        <meta name="author" content="DriveIn Team" />
      </Helmet>
       <Hero
       title={
  <>
   
    <span className="highlight">Scalable Franchise Business Opportunity –{" "}</span> <br />
   Automotive Service Channel Partner in Bangalore
  </>
}
        bgImage={banner}
        onButtonClick={handleServicesClick}
        buttonText="Contact Us"
      />
      <PartnerIntro/>
      <WhyChooseDriveIn/>
      <StartupRequirements/>
      {/* <JoinUsSection/> */}
      <ChannelPartnerApplySection/>
      <FaqSection faq={channelPartnerFaq}/>
      <ConsultationNote/>
    </>
  );
};

export default AboutUs;

